import { IAuthInterceptorConfiguration } from './models/interceptor-configuration.interface';
import { TOKEN_API } from './tokens';

export function MSALInterceptorConfigFactory(
  angularConfiguration: IAuthInterceptorConfiguration,
): IAuthInterceptorConfiguration {
  return {
    ...angularConfiguration,
    unprotectedResources:
      angularConfiguration.unprotectedResources.concat(TOKEN_API),
  };
}
